<template>
  <form
    class="grid text-center relative justify-center justify-items-center py-2"
    @submit.prevent="
        $route.query?.redirect?.toLocaleLowerCase()?.includes('guarantor') ?
         guarantorOtp() :
         customerOtp()
      "
    @paste="handlePaste"
    @input="handleInput"
    @keyup.delete="handleDeletion"
    ref="form"
  >
    <h1 class="text-2xl font-black">Verification</h1>
    <p class="text-gray-500">Enter 4 digit code sent to {{ $route.params.phone || phone }}</p>
    <div
      class="grid gap-4 mt-3 md:mt-6 grid-cols-4 max-w-xs justify-items-center justify-center justify-self-center"
    >
      <input
        type="text"
        class="input input--single"
        inputmode="numeric"
        v-model.trim="otp[0]"
        required
        name="1"
        minlength="1"
        maxlength="1"
        autofocus
        tabindex="1"
        @keypress="isNumber"
      />
      <input
        type="text"
        class="input input--single"
        inputmode="numeric"
        v-model.trim="otp[1]"
        required
        name="2"
        minlength="1"
        maxlength="1"
        @keypress="isNumber"
      />
      <input
        type="text"
        class="input input--single"
        inputmode="numeric"
        v-model.trim="otp[2]"
        required
        name="3"
        minlength="1"
        maxlength="1"
        @keypress="isNumber"
      />
      <input
        type="text"
        class="input input--single"
        inputmode="numeric"
        v-model.trim="otp[3]"
        required
        name="4"
        minlength="1"
        maxlength="1"
        @keypress="isNumber"
      />
    </div>
    <span class="max-w-xs mt-4 text-gray-600 text-sm w-96">
      Having troubles receiving the OTP? &nbsp;
      <button
        v-if="!timer"
        id="resend-button"
        class="text-primary"
        type="button"
        @click.prevent="
          $route.query?.redirect?.toLocaleLowerCase()?.includes('guarantor') ?
          setGuarantorResendOtp() :
          resendOtp()
        "
      >Resend OTP</button>
      <template v-else>
        <span>Resend OTP in</span>&nbsp;
        <br />
        <span class="text-primary">{{ timer }}s</span>
      </template>
    </span>
    <fieldset class="label text-left w-72 mt-4" v-if="showReferrerCode">
      <label for="referal-code">Referral Code</label>
      <input
        type="text"
        name="referral-code"
        id="referral-code"
        class="text-base px-3 py-2 rounded border-textPrimary border w-full placeholder-gray-300 focus:outline-none focus:ring focus:border-primary disabled:bg-white disabled:text-gray-400"
        v-model.trim="referrerCode"
      />
    </fieldset>
    <fieldset class="text-left w-72 mt-4 flex gap-4" v-if="!tncAccepted">
      <span class="p-px">
        <input type="checkbox" name="tnc" id="tnc" required class="text-primary" />
      </span>
      <label for="tnc">
        I have read, understood and I agree to content of this agreement, and I hereby consent to "Arthashastra EpayLater Financial Private Limited" being appointed as your authorized representative to receive your Credit Information from Experian for the purpose of providing offers on credit products and assessing credit eligibility of the customer ("End Use Purpose"), on month on month basis for  a period of six (6) months. I also agree to
        <a
          href="https://s3.ap-south-1.amazonaws.com/epaylater-marketing/Experian_Terms.pdf"
          target="_blank"
          class="text-primary underline"
        >Experian Terms and Conditions</a>
        &
        <a
          class="text-primary underline"
          :href="tncLink"
          target="_blank"
        >ePayLater Standard Terms and Conditions will be links as earlier</a>.
      </label>
    </fieldset>
    <div class="">
      <p class="text-errorColor text-sm mt-4 text-left" v-if="errorMessage">{{ errorMessage }}</p>
    </div>
    <custom-button
      variant="primary"
      class="mt-8 justify-center font-extrabold"
      type="submit"
      :loading="loading"
    >Continue</custom-button>
  </form>
</template>
<script>
import { mapGetters } from "vuex";
import CustomButton from "../components/CustomButton.vue";

export default {
  name: "VerifyOtp",
  components: {
    CustomButton
  },
  computed: {
    ...mapGetters(["sessionId", "isReferralFlow", "phone", 'guarantorLoanId', 'guarantorData'])
  },
  data() {
    return {
      otp: [],
      loading: undefined,
      timer: 30,
      timerInterval: undefined,
      errorMessage: undefined,
      tncLink: undefined,
      tncAccepted: undefined,
      showReferrerCode: undefined,
      referrerCode: undefined,
      loginData: undefined
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const sessionId = this.$route.query.session;
      if (sessionId) {
        this.$store
          .dispatch("customerPhoneBySession", { queryParams: { sessionId } })
          .then(result => {
            if (!result.phone) {
              this.redirectToMobileNoPage();
            } else if (result?.jwtAuthenticationResponse) {
              this.$store.commit("SAVE_TOKEN", result?.jwtAuthenticationResponse);
              this.$store.commit("PARSE_JWT", result?.jwtAuthenticationResponse?.accessToken);
              if (this.isReferralFlow) {
                this.$router.push({ name: "Signup" });
              }
              this.homeFlags();
            } else {
                const params = {
                  phone: result.phone,
                  sessionId: this.sessionId,
                };
                this.$store
                .dispatch('customerLogin', params)
                .then((response) => {
                  this.loginData = response;
                  this.loading = false;
                  this.$router.push({
                    name: 'Verify Otp',
                    params: { phone: this.phone },
                    query: { ...this.$route.query, ...response },
                  });
                })
                .catch((err) => {
                  this.errorMessage = err.message;
                  this.loading = false;
                });
              }
            this.tncAccepted = result.tncAccepted;
          })
          .catch(() => {
            this.redirectToMobileNoPage();
          });
      } else if (!this.$route.params.phone) {
        this.redirectToMobileNoPage();
      }
      this.startTimer();
      this.tncLink = this.$route.query.tncLink;
      this.tncAccepted = JSON.parse(this.$route.query.tncAccepted);
      this.showReferrerCode = JSON.parse(this.$route.query.showReferrerCode);
    },
    redirectToMobileNoPage() {
      this.$router.push({ name: "Mobile No", query: this.$route.query });
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    customerOtp() {
      this.$trackEvent(this.$mixpanelEvent.OTP_ENTERED, {
        [this.$mixpanelPayload.REF_CODE]: this.referrerCode,
      });
      this.loading = true;
      const params = {
        otp: this.otp.join(""),
        sessionId: this.sessionId,
        referrerCode: this.referrerCode,
        tncId: this.loginData?.tncId || parseInt(this.$route.query?.tncId, 10)
      };
      this.$store
        .dispatch("customerOtp", params)
        .then(() => {
          this.loading = false;
          if (this.isReferralFlow) {
            this.$router.push({ name: "Signup" });
          } else if (this.$route.query.redirect) {
            this.getHome().then((result) => {
              const uuid = result?.customer?.uuid;
              this.$trackUuid(uuid);
              this.$trackUserProfile({
                applicationStatus: result?.application.status?.value,
                applicationSubStatus: result?.application.subStatus,
                isServiceable: result?.isServiceable
              });
              this.$router.push({
                name: this.$route.query.redirect,
                query: this.$route.query
              });
            });
          } else {
            this.$router.push({
              name: "Dashboard",
              query: this.$route.query
            });
          }
          this.homeFlags();
        })
        .catch(err => {
          this.$trackEvent(this.$mixpanelEvent.LOGIN_FAILURE, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message,
          });
          this.errorMessage = err.message;
          this.loading = false;
        });
    },
    guarantorOtp() {
      this.loading = true;
      const params = {
        loanId: this.guarantorLoanId,
        postParams: {
          otp: this.otp.join(""),
          sessionId: this.sessionId,
        },
      };
      this.$store
        .dispatch("guarantorVerifyOtp", params)
        .then((result) => {
          this.loading = false;
          if (result?.isGuarantor) {
            this.getGuarantorSummary();
          }
        })
        .catch(err => {
          this.errorMessage = err.message;
          this.loading = false;
        });
    },
    logout() {
      this.$store.dispatch('customerLogout');
    },
    getGuarantorSummary() {
      this.loading = true;
      const params = {
        loanId: this.guarantorLoanId,
      };
      this.$store
        .dispatch("guarantorSummary", params)
        .then((result) => {
          this.loading = false;
          if (result.status === "initiated") {
            this.$router.push({ name: "Guarantor Pan Verification" });
          } else if (result.status === "panNumberUpdated") {
            this.$router.push({ name: 'Guarantor Verification Details' });
          } else if (result.status === "personalInfoUpdated") {
            this.$router.push({ name: 'Guarantor Kyc' });
          } else if (result.status === "digiLockerVerified") {
            this.$router.push({ name: 'Guarantor KYC Success' });
          } else if (result.status === "aadharESigned") {
            this.$router.push({ name: 'Guarantor Verified' });
          }
        })
        .catch(err => {
          this.errorMessage = err.message;
          this.loading = false;
        });
    },
    getHome() {
      return new Promise((resolve, reject) => {
        this.isSpinLoading = true;
      this.$store
        .dispatch('home').then((result) => {
          resolve(result);
          this.isSpinLoading = false;
        })
        .catch((err) => {
          reject(err);
          this.isSpinLoading = false;
        });
      });
    },
    resendOtp() {
      this.$trackEvent(this.$mixpanelEvent.RESEND_OTP);
      const params = {
        phone: this.$route.params.phone || this.phone,
        sessionId: this.sessionId
      };
      this.$store
        .dispatch("customerResendOtp", params)
        .then(() => {
          this.timer = 30;
          this.startTimer();
        })
        .catch(() => { });
    },
    setGuarantorResendOtp() {
      const params = {
        loanId: this.guarantorLoanId,
      };
      this.$store
        .dispatch("guarantorResendOtp", params)
        .then(() => {
          this.timer = 30;
          this.startTimer();
        })
        .catch(() => { });
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    handleInput(e) {
      const input = e.target;
      if (input.nextElementSibling && input.value) {
        input.nextElementSibling.focus();
      } else if (input.previousElementSibling && !input.value) {
        input.previousElementSibling.focus();
      }
    },
    handlePaste(e) {
      const paste = e.clipboardData.getData("text");
      const { form } = this.$refs;
      const inputs = form.querySelectorAll(".input");
      inputs.forEach((input, i) => {
        input.value = paste[i] || "";
      });
    },
    handleDeletion(e) {
      const FormElement = document.getElementsByTagName("input");
      const inputName = e.target.name;
      if (inputName === '2' && FormElement[0].value) {
        if (FormElement[1].value) {
          FormElement[1].focus();
        } else {
          FormElement[0].focus();
        }
      } else if (inputName === '3' && FormElement[1].value) {
        if (FormElement[2].value) {
          FormElement[2].focus();
        } else {
          FormElement[1].focus();
        }
      } else if (inputName === '4' && FormElement[2].value) {
        if (FormElement[3].value) {
          FormElement[3].focus();
        } else {
          FormElement[2].focus();
        }
      }
    },
    homeFlags() {
      this.loading = true;
      this.$store.dispatch('homeFlags').then(() => {
        this.loading = false;
      });
    },
  }
};
</script>
